import layout from '@/components/common/layout';
import enterList from '../views/enterprise/list';
import enterCreate from '../views/enterprise/create';
import enterContractList from '../views/enterprise/list-contract';

export default [
    {
        path: '/enterprise',
        component: layout,
        children: [
            {
                path: 'list',
                meta: {
                    metaInfo: {
                        title: "企业列表",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '10',// 父选项
                        child: 'enterprise_list',// 子选项
                    }
                },
                component: enterList,
            },
            {
                path: 'create',
                meta: {
                    metaInfo: {
                        title: "新增企业",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '10',// 父选项
                        child: 'enterprise_list',// 子选项
                    }
                },
                component: enterCreate,
            },
            {
                path: 'edit',
                meta: {
                    metaInfo: {
                        title: "编辑企业",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '10',// 父选项
                        child: 'enterprise_list',// 子选项
                    }
                },
                component: enterCreate,
            },
            {
                path: 'list-contract',
                meta: {
                    metaInfo: {
                        title: "合同提醒",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '10',// 父选项
                        child: 'enterprise_list_contract',// 子选项
                    }
                },
                component: enterContractList,
            },
        ]
    },
];
